import * as types from '../constants/ActionTypes'
import {handleActions} from 'redux-actions'

const reducers = {}
reducers[types.GET_CHAT_HISTORY] = (state, action) => {
	return Object.assign({}, state, {
		isLoading: true,
		isSaving: false,
		isClearing: false,
		isLoaded: false,
		isSaved: false,
		isCleared: false,
		loadError: false,
		saveError: false,
		clearError: false
	})
}

reducers[types.GET_CHAT_HISTORY_FINISH] = {
	next(state, action) {
		return Object.assign({}, state, {
			[action.payload.chatHistory.email]: action.payload.chatHistory.messages,
			isLoading: false,
			isLoaded: true
		})
	},
	throw(state, action) {
		return Object.assign({}, state, {isLoading: false, loadError: true})
	}
}
reducers[types.GET_CHART_HISTORY_FINISH] = {
    next(state, action) {
        return Object.assign({}, state, {
            [action.payload.chatHistory.email]: action.payload.chatHistory.messages,
            isLoading: false,
            isLoaded: true
        })
    },
    throw(state, action) {
        return Object.assign({}, state, {isLoading: false, loadError: true})
    }
}
reducers[types.SAVE_CHAT] = (state, action) => {
	return Object.assign({}, state, {isSaving: true, isSaved: false, saveError: false})
}

reducers[types.SAVE_CHAT_FINISH] = {
	next(state, action) {
		return Object.assign({}, state, {isSaving: false, isSaved: true})
	},
	throw(state, action) {
		return Object.assign({}, state, {isSaving: false, saveError: true})
	}
}

reducers[types.CLEAR_CHAT_HISTORY] = (state, action) => {
	return Object.assign({}, state, {isClearing: true, isCleared: false, clearError: false})
}

reducers[types.CLEAR_CHAT_HISTORY_FINISH] = {
	next(state, action) {
		var newState = Object.assign({}, state)
		delete newState[action.payload.customerId]

		return Object.assign({}, newState, {isClearing: false, isCleared: true})
	},
	throw(state, action) {
		return Object.assign({}, state, {isClearing: false, clearError: true})
	}
}

reducers.setChat = {
	next(state = initialState, action) {

			return Object.assign({}, state, action.payload);
	}
}

export default handleActions(reducers, {})
